import React from 'react'

const HeaderEmail = () => {
  return (
    <div className="header__email">
        <a href='mailto:(mannemsrivishnureddy@gmail.com)' target="_blank" rel="noopener noreferrer">mannemsrivishnureddy@gmail.com</a>
    </div>
  )
}

export default HeaderEmail